import { selectUserShortcuts, updateShortcuts } from 'containers/Login/loginSlice'
import { addNotification } from 'containers/Notifications/notificationsSlice'
import { useDispatch, useSelector } from 'react-redux'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { availableShortcuts } from '../constans'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'
import { useState } from 'react'
import '../style.scss'

const EditShortcutsPopup = () => {
  const [isSending, setSending] = useState(false)
  const shortcuts = useSelector(selectUserShortcuts)
  const [selectedKeys, selectKeys] = useState(shortcuts.map(s => s.value))

  const dispatch = useDispatch()
  const { goBack } = useHistory()
  const { t } = useTranslation('dashboard')

  const sendShortcuts = async () => {
    if (isSending) return
    setSending(true)
    try {
      const response = await POST(urls.shortcuts, { body: { shortcuts: selectedKeys } })
      if (response.success && response.data) {
        dispatch(updateShortcuts(response.data))
        goBack()
      } else {
        throw new Error()
      }
    } catch (error) {
      setSending(false)
    }
  }

  return (
    <Popup>
      <div className='popup__title'>
        <div>{t('shortcuts')}</div>
      </div>

      <div className='popup__shortcuts'>
        <div className='favorite'>
          <h3>{t('pinned')} (Max 6)</h3>
          {selectedKeys.map(key => <div
            key={key}
            className='favorite__item'>
            <div
              className='iconWrap --red'
              onClick={() => {
                if (isSending) return
                selectKeys(selectedKeys.filter(k => k !== key))
              }}>
              <i className='icon icon--minus'></i>
            </div>
            <span>{t(key)}</span>
          </div>)}
        </div>

        <div className='rest'>
          <h3>{t('other')}</h3>
          {availableShortcuts.map(key => {
            if (selectedKeys.includes(key)) return null
            return <div
              key={key}
              className='favorite__item'>
              <div
                className='iconWrap --green'
                onClick={() => {
                  if (isSending) return
                  if (selectedKeys.length > 5) dispatch(addNotification({
                    type: 'error',
                    message: t('maximumNumberOfShortcutsExceeded')
                  }))
                  else selectKeys([...selectedKeys, key])
                }}>
                <i className='icon icon--plus'></i>
              </div>
              <span>{t(key)}</span>
            </div>
          })}
        </div>
      </div>

      <ArrowBtn
        enlarged
        showArrow={false}
        disabled={isSending}
        text={t(isSending ? 'saving' : 'save')}
        action={sendShortcuts}
      />
    </Popup>
  )
}

export default EditShortcutsPopup
